export enum ReferralRewardStatusEnum {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PAID = "PAID",
  REVIEW = "REVIEW",
  FAILED = "FAILED",
  LIMIT_REACHED = "LIMIT_REACHED",
  RESOLVED = "RESOLVED"
}

export enum ReferralAllocationStatusEnum {
  PENDING = "PENDING",
  WALLET_HOP_STARTED = "WALLET_HOP_STARTED",
  WALLET_HOP_DONE = "WALLET_HOP_DONE",
  MANDATE_HOP_STARTED = "MANDATE_HOP_STARTED",
  TRANSFERRED = "TRANSFERRED",
  INVESTING = "INVESTING",
  INVESTED = "INVESTED",
  REVIEW = "REVIEW"
}
